import FtuxModal from 'components/FtuxModal'
import { ReactComponent as DigitalTwin } from './digital-twin.svg'

const TwinFtuxModal = ({ onButtonClick, onClose }: { onButtonClick: () => void; onClose: () => void }) => {
  return (
    <FtuxModal
      onClose={onClose}
      headerText="Welcome to your digital twin!"
      subtitleText="We’ll guide you through the process of adding data so that your twin can respond to incoming requests as accurately as possible."
      buttonText="Get a quick tour"
      onButtonClick={onButtonClick}
      icon={
        <DigitalTwin
          style={{
            height: '160px',
            width: '160px',
          }}
        />
      }
    />
  )
}

export default TwinFtuxModal
